export const IMPLANT_REPORT = {
	IMPLANT_REPORT_LIST_ITEM: 'IMPLANT_REPORT_LIST_ITEM',
	IMPLANT_REPORT_GLOBAL: 'IMPLANT_REPORT_GLOBAL',
	CHANGE_INFO: 'CHANGE_INFO',
};
